// Zoho SalesIQ live chat. The widget code (wc) is a public identifier, not a secret.
// Override REACT_APP_SALESIQ_SRC to point staging builds at a different widget.
export const SALESIQ_SRC =
  process.env.REACT_APP_SALESIQ_SRC ||
  "https://salesiq.zoho.in/widget?wc=siq3db6988525cb2486a9c663a64d90cf1768f81a1114db6c3ad139a182fc5321cc";

export const CONSENT_KEY = "dopove-chat-consent";
